import { useLocation } from "react-router-dom";
import Seo, {
  DEFAULT_DESCRIPTION,
  DEFAULT_IMAGE,
  DEFAULT_KEYWORDS,
  SITE_URL,
} from "./Seo";

const BUSINESS_SCHEMA = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Store",
      name: "The 3D Creator",
      url: SITE_URL,
      image: DEFAULT_IMAGE,
      logo: DEFAULT_IMAGE,
      description: DEFAULT_DESCRIPTION,
      telephone: "+91 8223839384",
      email: "support@the3dcreator.com",
      priceRange: "INR",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Inner Bypass, Near India Oil Petrol Pump",
        addressLocality: "Bhatapara",
        addressRegion: "Chhattisgarh",
        postalCode: "493118",
        addressCountry: "IN",
      },
      areaServed: "IN",
      sameAs: [
        "https://www.instagram.com/the3dcreator.co/",
        "https://www.facebook.com/profile.php?id=61586690636144",
      ],
      knowsAbout: [
        "Custom 3D printed products",
        "Personalised gifts",
        "Corporate gifting",
        "Bulk 3D printing orders",
        "Birthday gifts",
        "Desk accessories",
      ],
    },
    {
      "@type": "WebSite",
      name: "The 3D Creator",
      url: SITE_URL,
      potentialAction: {
        "@type": "SearchAction",
        target: `${SITE_URL}/products?search={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
  ],
};

const routeSeo = {
  "/": {
    title:
      "Custom 3D Printed Gifts, Corporate Gifting & Bulk Orders | The 3D Creator",
    description:
      "Discover custom 3D printed gifts, personalised keepsakes, birthday presents, desk accessories, corporate gifting, and bulk 3D print orders crafted by The 3D Creator.",
    keywords:
      "custom 3d printed gifts, personalised gifts india, corporate gifting, bulk 3d print orders, birthday return gifts, custom desk accessories, 3d printed keychains, 3d printed name plates",
    structuredData: BUSINESS_SCHEMA,
  },
  "/products": {
    title:
      "Custom 3D Printed Products, Personalised Gifts & Bulk Orders | The 3D Creator",
    description:
      "Browse custom 3D printed products for gifting, branding, decor, birthdays, events, and corporate gifting. Order personalised 3D printed items in single or bulk quantities.",
  },
  "/contact": {
    title: "Contact The 3D Creator | Custom 3D Printing & Gifting",
    description:
      "Contact The 3D Creator for custom 3D printed gifts, corporate gifting, bulk 3D print orders, product enquiries, and personalised design support.",
  },
  "/terms-and-conditions": {
    title: "Terms and Conditions | The 3D Creator",
    description:
      "Read the terms and conditions for ordering custom 3D printed products, personalised gifts, and made-to-order items from The 3D Creator.",
  },
  "/privacy-policy": {
    title: "Privacy Policy | The 3D Creator",
    description:
      "Read how The 3D Creator collects, uses, and protects customer data for custom 3D printed products, gifting orders, and enquiries.",
  },
  "/return-policy": {
    title: "Refund and Return Policy | The 3D Creator",
    description:
      "Review the refund, return, and replacement policy for custom 3D printed products and personalised gift orders from The 3D Creator.",
  },
  "/cart": {
    title: "Your Cart | The 3D Creator",
    description:
      "Review your selected custom 3D printed products and gifting items before checkout.",
    noindex: true,
  },
  "/address": {
    title: "Delivery Address | The 3D Creator",
    description:
      "Manage delivery details for your custom 3D printed product order.",
    noindex: true,
  },
  "/login": {
    title: "Login | The 3D Creator",
    description:
      "Log in to manage your account, orders, and personalised 3D printed purchases.",
    noindex: true,
  },
};

export default function SeoManager() {
  const location = useLocation();
  const routeConfig = routeSeo[location.pathname] || {
    title:
      "Custom 3D Printed Gifts, Personalised Products & Corporate Orders | The 3D Creator",
    description: DEFAULT_DESCRIPTION,
    keywords: DEFAULT_KEYWORDS,
  };

  if (
    location.pathname.startsWith("/p/") ||
    location.pathname.startsWith("/product-details/")
  ) {
    return null;
  }

  return (
    <Seo
      title={routeConfig.title}
      description={routeConfig.description}
      keywords={routeConfig.keywords || DEFAULT_KEYWORDS}
      pathname={location.pathname}
      image={routeConfig.image || DEFAULT_IMAGE}
      noindex={routeConfig.noindex || false}
      structuredData={routeConfig.structuredData || null}
    />
  );
}
